import { render, staticRenderFns } from "./SelectItemButtons.vue?vue&type=template&id=1021e304&scoped=true&"
import script from "./SelectItemButtons.vue?vue&type=script&lang=js&"
export * from "./SelectItemButtons.vue?vue&type=script&lang=js&"
import style0 from "./SelectItemButtons.vue?vue&type=style&index=0&id=1021e304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1021e304",
  null
  
)

export default component.exports